import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { numberPadding } from '../../../utils/formatting';
const cn = require('classnames');
const _ = require('lodash');

export default class UserForm extends React.Component {

    constructor(props) {
        super(props);
        this.updateUserData = this._updateUserData.bind(this);
        this.handleSubmit = this._handleSubmit.bind(this);
        this.state = {
            user : null
        };
    }

    componentWillReceiveProps(props) {
        if(props.show && ! this.props.show) {
            this.updateUserData(props.user);    
        }
    }

    _updateUserData(data) {
        const user = this.state.user;
        const newData = data ? {
            ...user,
            ...data
        } : {role : this.props.role};
        this.setState({
            user : newData
        });
    }

    _handleSubmit(event) {
        event.preventDefault();
        const user = this.state.user;
        this.props.saveUser(user);
    }

    render() {
        const territories = this.props.territories.fetching ? [] : Object.values(this.props.territories.data);
        const coordinations = this.props.coordinations.fetching ? [] : Object.values(this.props.coordinations.data);
        const user = this.state.user || {};
        const role = this.props.role;
        const error = this.props.error || {};
        const filteredCoordinations = coordinations.filter(coordination => coordination.territory_id === user.territory_id)
        const exists = user ? (user.created_at ? true : false) : false;
        const unhandledErrors = _.difference(Object.keys(error), ['emp_number', 'name', 'email', 'territory_id', 'coordination_id']).reduce((arr, key) => {
            const errors = error[key];
            if(Array.isArray(errors) && errors.length > 0) {
                return arr.concat(errors);
            }
            return arr;
        }, []);
        return (
            <Modal isOpen={this.props.show} toggle={this.props.hideModal}>
                <ModalHeader toggle={this.props.hideModal}>
                    {exists ? 'Editar ' + this.props.roleName + ' '+ numberPadding(user.emp_number, 6) : 'Dar de alta nuevo ' + this.props.roleName}
                </ModalHeader>
                <ModalBody>
                    <form ref="form" onSubmit={this.handleSubmit}>

                        {
                            unhandledErrors.map(err => (
                                <p className="text-danger">{err}</p>
                            ))
                        }

                        {
                            role !== 'admin' ?
                            <div className={cn("form-group","row", {'has-danger' : (error.territory_id || []).length})}>
                                <label htmlFor="territory_id" className="form-control-label col-sm-3">Territorio</label>
                                <div className="col-sm-9">
                                    <select className="form-control" onChange={event => this.updateUserData({territory_id : parseInt(event.target.value, 10), coordination_id : null}) } value={user.territory_id || ''}>
                                        {
                                            user.territory_id ? null :
                                            <option key={0}>
                                                Seleccione un territorio
                                            </option>
                                        }
                                        
                                        {
                                            territories.map(territory => 
                                                <option key={territory.id} value={territory.id}>
                                                    {territory.name}
                                                </option>
                                            )
                                        }
                                    </select>
                                    {
                                        (error.territory_id || []).map((err,i) => (
                                            <div key={i} className="form-control-feedback">{err}</div>
                                        ))
                                    }
                                </div>
                            </div>
                            :null
                        }
                        {
                            role !== 'admin' && role !== 'subdirector' ?
                            <div className={cn("form-group","row", {'has-danger' : (error.coordination_id || []).length})}>
                                <label htmlFor="coordination_id" className="form-control-label col-sm-3">Coordinación</label>
                                <div className="col-sm-9">
                                    <select className="form-control" onChange={event => this.updateUserData({coordination_id : parseInt(event.target.value, 10)})} value={user.coordination_id || ''}>
                                        {
                                            user.territory_id ?
                                            (user.coordination_id ? null : <option>Seleccione una coordinación</option>)    
                                            : <option>Seleccione un territorio</option>
                                        }
                                        
                                        {
                                            filteredCoordinations.map(coordination => 
                                                <option key={coordination.id} value={coordination.id}>
                                                    {coordination.name}
                                                </option>
                                            )
                                        }
                                    </select>
                                    {
                                        (error.coordination_id || []).map((err,i) => (
                                            <div key={i} className="form-control-feedback">{err}</div>
                                        ))    
                                    }
                                    
                                </div>
                            </div>
                            :null
                        }

                        <div className={cn("form-group","row", {'has-danger' : (error.emp_number || []).length})}>
                            <label htmlFor="emp_number" className="form-control-label col-sm-3">Número de empleado</label>
                            <div className="col-sm-9">
                                <input type="number" className="form-control" maxLength={6} value={exists ? numberPadding(user.emp_number, 6) : (user.emp_number || '')} readOnly={exists ? true : null} onChange={event => this.updateUserData({emp_number : event.target.value.substring(0, 6)})}/>
                                {
                                    (error.emp_number || []).map((err,i) => (
                                        <div key={i} className="form-control-feedback">{err}</div>
                                    ))
                                }
                            </div>
                        </div>                        

                        <div className={cn("form-group","row", {'has-danger' : (error.name || []).length})}>
                            <label htmlFor="name" className="form-control-label col-sm-3">Nombre</label>
                            <div className="col-sm-9">
                                <input type="text" className="form-control" maxLength={150} value={user.name || ''} onChange={event => this.updateUserData({ name : event.target.value})}/>
                                {
                                    (error.name || []).map((err,i) => (
                                        <div key={i} className="form-control-feedback">{err}</div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className={cn("form-group","row", {'has-danger' : (error.email || []).length})}>
                            <label htmlFor="name" className="form-control-label col-sm-3">E-Mail</label>
                            <div className="col-sm-9">
                                <input type="email" className="form-control" maxLength={50} value={user.email || ''} onChange={event => this.updateUserData({ email : event.target.value})}/>
                                {
                                    (error.email || []).map((err,i) => (
                                        <div key={i} className="form-control-feedback">{err}</div>
                                    ))
                                }
                            </div>
                        </div>
                    </form>
                </ModalBody>

                <ModalFooter>
                    <button className="btn btn-secondary mr-1" onClick={this.props.hideModal}>Cancelar</button>
                    <button className="btn btn-primary" onClick={this.handleSubmit}> <i className="fa fa-fw fa-save"></i> Guardar</button>
                </ModalFooter>
            </Modal>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/presentation/users/UserForm.jsx
 **/